<template>
  <div class="vue_flex vue_column">
    <div class="cont_wrapper">
      <el-table
        :data="tableData"
        :header-cell-style="{ backgroundColor: '#f5f7fa', color: '#333' }"
        style="width: 100%"
        height="81vh"
        key="costtable"
      >
        <el-table-column
          prop="lv1"
          label="一级科目"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="lv2"
          label="二级科目"
          align="center"
        ></el-table-column>
      </el-table>
    </div>
  </div>
</template>
<script>
import Pagination from "@/components/Pagination"; // secondary package based on el-pagination

export default {
  components: { Pagination },
  data() {
    return {
      total: 0,
      listQuery: {
        page: 1,
        limit: 10,
      },

      tableData: [
        {
          lv1: "固定费⽤",
          lv2: "1001管理费⽤",
        },
        {
          lv1: "",
          lv2: "1002销售费⽤",
        },
        {
          lv1: "",
          lv2: "1003财务费⽤",
        },
        {
          lv1: "",
          lv2: "1004营业税⾦及附加",
        },
        {
          lv1: "",
          lv2: "1005开发⽀出",
        },
        {
          lv1: "",
          lv2: "1006房租⽔电",
        },
        {
          lv1: "",
          lv2: "1007⼈⼯⽀出",
        },
        {
          lv1: "",
          lv2: "1099其他费⽤",
        },
        {
          lv1: "其他销售费⽤",
          lv2: "2001仓储费⽤",
        },
        {
          lv1: "",
          lv2: "2002包装费⽤",
        },
        {
          lv1: "",
          lv2: "2003拍摄费⽤",
        },
        {
          lv1: "",
          lv2: "2004赠品费⽤",
        },
        {
          lv1: "",
          lv2: "2005特殊单费⽤",
        },
        {
          lv1: "售后费⽤",
          lv2: "3001质量补偿费⽤",
        },
        {
          lv1: "",
          lv2: "3002退运费费⽤",
        },
        {
          lv1: "",
          lv2: "3003仅退款费⽤损失",
        },
        {
          lv1: "平台费⽤",
          lv2: "4001平台佣⾦扣点",
        },
        {
          lv1: "",
          lv2: "4002平台活动扣点",
        },
        {
          lv1: "",
          lv2: "4003平台其他费⽤",
        },
      ],
    };
  },
  mounted() {},

  methods: {
    getHetongListFun() {},
  },
};
</script>

<style lang="scss" scoped>
.cont_wrapper {
  padding: 25px;
  .cont_wrapper_sx {
    width: 1527px;
    height: 71px;
    background: #f5f5f5;
    border-radius: 10px;
    padding: 0 20px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    .shaixuan_left {
      display: flex;
      flex-direction: row;
      justify-content: start;
      align-items: center;
    }
    .shaixuan_item {
      width: 350px;
      height: 54px;
      background: #ffffff;
      border-radius: 10px;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      padding: 0 20px;
      margin-right: 22px;
      .shaixuan_item_con {
        display: flex;
        flex-direction: row;
        justify-content: start;
        align-items: center;
        .shaixuan_item_tit {
          font-family: PingFang SC;
          font-weight: 500;
          font-size: 18px;
          color: #232323;
        }
        .shaixuan_item_sel {
          font-family: PingFang SC;
          font-weight: 500;
          font-size: 18px;
          color: #999999;
        }
        .shaixuan_item_arr {
          width: 13px;
          height: 8px;
          margin-left: 10px;
        }
        .shaixuan_item_icon {
          width: 29px;
          height: 24px;
          margin-right: 10px;
        }
      }
    }
  }
}

.shaixuan_item {
  .el-input /deep/.el-input__inner {
    border: none !important;
    text-align: right;
    font-size: 18px;
  }
  .el-input /deep/.el-input__prefix {
    display: none !important;
  }

  .el-select /deep/.el-input__inner {
    border: none !important;
    text-align: right;
    font-size: 18px;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/main/level1/costmanage/subject/index.vue